import { frontendURL } from '../../../../helper/URLHelper';
import store from 'dashboard/store';
import SettingsWrapper from '../SettingsWrapper.vue';
import ConversationWorkflowIndex from './index.vue';

const requireInstallationSuperAdmin = (to, _from, next) => {
  if (store.getters.getCurrentUser?.type === 'SuperAdmin') {
    next();
    return;
  }

  const accountId = to.params.accountId ?? store.getters.getCurrentAccountId;
  if (!accountId) {
    next('/app/login');
    return;
  }

  next({
    path: frontendURL(`accounts/${accountId}/settings/general`),
  });
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/conversation-workflow'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'conversation_workflow_index',
          component: ConversationWorkflowIndex,
          meta: {
            permissions: ['administrator'],
          },
          beforeEnter: requireInstallationSuperAdmin,
        },
      ],
    },
  ],
};
